/** Accept a URL or host and return a lowercase *.myshopify.com hostname. */
export const normalizeShopifyExternalId = (raw: string): string | null => {
  const trimmed = raw.trim().toLowerCase();
  if (!trimmed) {
    return null;
  }

  let host = trimmed;
  try {
    if (trimmed.includes('://')) {
      host = new URL(trimmed).hostname;
    } else {
      host = trimmed.split('/')[0]?.split('?')[0] ?? '';
    }
  } catch {
    return null;
  }

  return host.endsWith('.myshopify.com') ? host : null;
};

export const SHOPIFY_EXTERNAL_PLATFORM_ID_MISMATCH_ERROR =
  'Shop domain does not match this merchant.';

/** True when this merchant is bound to a Shopify shop (*.myshopify.com). */
export const isShopifyMerchant = (externalPlatformId?: string | null): boolean =>
  Boolean(externalPlatformId && normalizeShopifyExternalId(externalPlatformId));

export const getShopifyExternalPlatformIdMismatchError = (
  shopDomain: string,
  merchantExternalPlatformId?: string | null,
): string | undefined => {
  const normalizedShopDomain = normalizeShopifyExternalId(shopDomain);
  if (!normalizedShopDomain || !merchantExternalPlatformId) {
    return undefined;
  }

  const normalizedMerchantId =
    normalizeShopifyExternalId(merchantExternalPlatformId) ??
    merchantExternalPlatformId.trim().toLowerCase();

  if (normalizedShopDomain === normalizedMerchantId) {
    return undefined;
  }

  return SHOPIFY_EXTERNAL_PLATFORM_ID_MISMATCH_ERROR;
};
